import { useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useAuth } from '../../../../app/modules/auth'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { User } from '../../../../app/modules/profile/components/User'
import { Locale } from '../../../../app/modules/profile/components/Locale'
import { NotificationPreferences } from '../../../../app/modules/profile/components/NotificationPreferences'
import { Referral } from '../../../../app/modules/profile/components/Referral'
import {
  EmailPreferencesOutput,
  localeInitialValues,
  userInitialValues,
} from '../../../../app/modules/profile/core/_constants'
import {
  getLocale,
  getReferralData,
  getTotalReferralEarning,
  profileData,
} from '../../../../app/modules/profile/core/_requests'
import { CountryModel } from '../../../../app/modules/onboarding'
import { getCountry, state } from '../../../../app/modules/onboarding/core/_requests'
import useGetBillingData from '../../../../app/hooks/useGetBillingData'
import { useLayout } from '../../../../_metronic/layout/core'
import { Toolbar } from '../../../../_metronic/layout/components/toolbar/Toolbar'
import { getCompanyMetaIdType } from '../../profile/core/_models'
// import 'react-best-tabs/dist/index.css'
import '../../../../app/modules/widgets/components/styles/rectangularTabs.scss'
// import { OtherUserSettings } from '../../profile/components/OtherUsersSettings'
// import RectangularTabs from '../../widgets/components/RectangularTabs'
import { getEmailPreferences } from '../../../../app/modules/profile/core/_requests'
import Security from '../../profile/components/Security'
import AIMemory from '../../recordskeeper-ai/components/SettingsAndPolicies/AIMemory'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { ReferralRK } from '../../profile/components/ReferralRK'
// import { PaymentDue } from '../../dashboard/components/PaymentDue'

const UserSettings = () => {
  const { formatMessage } = useIntl()
  const { config } = useLayout()
  const {
    currentUser,
    setCurrentUser,
    companyId,
    setCurrentState,
    setSelected,
    setCurrencyBill,
    billingData,
    setBillingData,
    setEntitlements,
    setCompanyCurrency,
  } = useAuth()

  const [getApiLoading, setApiLoading] = useState(false)
  const [imgName, setImgName] = useState<string>()
  const [getLocaleApiLoading, setGetLocaleApiLoading] = useState(false)
  const [getPreferencesApiLoading, setgetPreferencesApiLoading] = useState(false)
  const [countryOptions, setcountryOptions] = useState<any[]>([])
  const [stateOptions, setstateOptions] = useState<any[]>([])
  const [getPreferences, setGetPreferences] = useState(EmailPreferencesOutput)
  const [countryId, setCountryId] = useState<string | undefined>()
  const [referral, setReferral] = useState<string>()
  const [paypalId, setPaypalId] = useState<string>()
  const [totalEarning, setTotalEarning] = useState<string>()
  const [totalReferred, setTotalReferred] = useState<string>()
  const [showHelpBanners, setshowHelpBanners] = useState(true)
  const { getBillingDetailsAPI } = useGetBillingData(companyId!)
  const [countryCode, setCountryCode] = useState<string>('')
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const isRKApp = process.env.REACT_APP_BRAND === 'RK'
  //rectangular tabs Starts
  const [tab, setTab] = useState(1)
  const options = [
    { title: formatMessage({ id: 'General' }), subTitle: formatMessage({ id: 'General Settings' }) },
    { title: formatMessage({ id: 'Locale' }), subTitle: formatMessage({ id: 'Locale Settings' }) },
    {
      title: formatMessage({ id: 'Notifications' }),
      subTitle: formatMessage({ id: 'Notifications Preferences' }),
    },
    { title: formatMessage({ id: 'Security' }), subTitle: formatMessage({ id: 'Enhanced protection' }) },
    { title: formatMessage({ id: 'AI Memory' }), subTitle: formatMessage({ id: 'AI Memory Settings' }) },
    { title: formatMessage({ id: 'Referrals' }), subTitle: formatMessage({ id: 'Referrals' }) },
    // { title: formatMessage({ id: 'Other Settings' }), subTitle: formatMessage({ id: 'Other Settings' }) },
  ]
  //rectangular tabs Ends

  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const tabParam = params.get('tab')
    const tabIndex = options.findIndex((opt) => opt.title.toLowerCase() === tabParam?.toLowerCase())
    if (tabIndex !== -1) {
      setTab(tabIndex + 1)
    } else {
      setTab(1) // Default to the first tab
      navigate(`${location.pathname}?tab=${options[0].title.toLowerCase()}`)
    }
  }, [location.search]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleTabChange = (index: number) => {
    setTab(index + 1)
    navigate(`${location.pathname}?tab=${options[index].title.toLowerCase()}`)
  }

  //rectangular tabs Ends
  useEffect(() => {
    const plan: any = billingData?.subscription_items[0].item_price_id?.split('-')
    if (plan) {
      setSelected(plan[0])
      setCurrencyBill(plan[1])
      setCompanyCurrency(currentUser?.company[0]?.currency?.code)
      setCurrentState(plan[2])
    }
  }, [billingData]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getBillingDetails = async () => {
      const result = await getBillingDetailsAPI()
      setBillingData({
        ...result.output,
        transaction_id: result.current_plan_invoice_id,
        company_country: result.company_country,
      })
      setEntitlements(result.entitlement_list)
    }
    if (companyId) {
      getBillingDetails()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const getReferral = async () => {
    try {
      const {
        data: { success, data, errors },
      } = await getReferralData()
      if (success) {
        setReferral(data.referCode)
        setPaypalId(data.paypalEmail)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  const totalReferralEarning = async () => {
    try {
      const {
        data: { success, data, errors },
      } = await getTotalReferralEarning()
      if (success) {
        setTotalEarning(data.earnings)
        setTotalReferred(data.totalReferred)
      } else {
        errors?.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getReferral()
    totalReferralEarning()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getProfileInfo = async () => {
    try {
      if (companyId) {
        setApiLoading(true)
        const {
          data: { success, data, errors },
        } = await profileData(companyId)
        if (success) {
          setApiLoading(false)
          setImgName(data.profileImage)
          setshowHelpBanners(data.showHelpBanners)
          setCurrentUser({
            ...currentUser,
            firstName: data.firstName,
            profileImg: data.profileImage,
          })
          setCountryId(data?.countryId)
          const communicationData = JSON.parse(data.communication)
          userInitialValues.firstName = data.firstName
          userInitialValues.lastName = data.lastName
          userInitialValues.email = data.email
          userInitialValues.contactNumber = data.contact!
          userInitialValues.countryDialingCode = data.countryDialingCode!
          userInitialValues.country = data.countryId
          userInitialValues.state = data.stateId
          userInitialValues.city = data.city
          userInitialValues.zipCode = data.zipCode
          userInitialValues.designation = data.designation
          userInitialValues.profileImageId = data.profileImageId!
          userInitialValues.communication.email = communicationData?.email || false
          userInitialValues.communication.phone = communicationData?.phone || false
          setCountryCode(data.countryDialingCode)
          setPhoneNumber(data.contact)
        } else if (errors) {
          setApiLoading(false)
          errors.forEach((error: string) => {
            toast.error(formatMessage({ id: error }))
          })
        }
      }
    } catch (err) {
      setApiLoading(false)
      console.log(err)
    }
  }
  useEffect(() => {
    getProfileInfo()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  const fetchEmailPrefrences = async () => {
    try {
      setgetPreferencesApiLoading(true)
      if (companyId) {
        const {
          data: {
            data: { preference },
            success,
          },
        } = await getEmailPreferences(companyId)
        if (success) {
          setGetPreferences(JSON.parse(preference))
        }
        setgetPreferencesApiLoading(false)
      }
    } catch (err) {
      setgetPreferencesApiLoading(false)
      // toast.error(formatMessage({id: 'Something went wrong'}))
      console.log(err)
    }
  }
  useEffect(() => {
    fetchEmailPrefrences()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const getCompanyMeta = async () => {
      try {
        if (companyId) {
          setGetLocaleApiLoading(true)
          const {
            data: { success, data, errors },
          } = await getLocale()
          if (success) {
            setGetLocaleApiLoading(false)
            data.map(({ key, value }: getCompanyMetaIdType) => {
              return (localeInitialValues[key] = value)
            })
            return null
          } else {
            setGetLocaleApiLoading(false)
            errors.forEach((error: string) => {
              toast.error(formatMessage({ id: error }))
            })
          }
        }
      } catch (err) {
        setGetLocaleApiLoading(false)
        console.log(err)
      }
    }
    getCompanyMeta()
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const fetchCountry = async () => {
      const {
        data: { data: countries },
      } = await getCountry()
      const countriesData = countries.map((country: CountryModel) => {
        return {
          id: country.countryId,
          name: country.country_name,
          value: country.countryId,
        }
      })
      setcountryOptions([...countriesData])
    }
    fetchCountry()
  }, [])

  useEffect(() => {
    const fetchState = async () => {
      try {
        if (!countryId) {
          return
        }
        const {
          data: { data: states, success },
        } = await state(countryId!)
        if (success) {
          const stateData = states.map((state: any) => {
            return {
              id: state.stateId,
              name: state.state_name,
              value: state.stateId,
            }
          })
          setstateOptions([...stateData])
        }
      } catch (err) {
        console.log(err)
      }
    }
    fetchState()
  }, [countryId]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!config.app?.toolbar?.display) {
    return null
  }

  return (
    <>
      {/* <PaymentDue /> */}
      <div className='px-6 d-flex flex-md-column align-items-start row'>
        <div className='d-md-flex d-flex justify-content-md-between w-100 pt-1 mb-4 col-12'>
          <div className='page-title d-flex flex-column justify-content-center flex-wrap me-3'>
            <h1 className='page-heading d-flex text-dark fw-bold fs-4 flex-column justify-content-center'>
              {formatMessage({ id: 'User Settings' })}
            </h1>
            <ul className='breadcrumb breadcrumb-separatorless fw-semibold font-size-12 my-2'>
              <li className='breadcrumb-item text-muted'>
                <a href='/' className='text-primary'>
                  {formatMessage({ id: 'Home' })}
                </a>
              </li>
              <li className='breadcrumb-item'>
                <span className='h-1px bullet'></span>
              </li>
              <li className='breadcrumb-item text-muted text-dark'>
                {formatMessage({ id: 'User Settings' })}
              </li>
            </ul>
          </div>
          <Toolbar />
        </div>
        <div
          className='p-0'
          style={{
            overflowX: 'scroll',
            whiteSpace: 'nowrap',
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
        >
          <div
            className='d-flex gap-3 px-md-3 col-md-8 col-12'
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
              scrollbarWidth: 'none',
              msOverflowStyle: 'none',
            }}
          >
            {/* Rectangular tabs Start */}
            {options.map((opt, index) => (
              <div
                key={index}
                className={
                  `col options-container p-4 align-content-center cursor-pointer  border border-muted` +
                  (tab === index + 1 ? ' selected-option  border-primary' : '')
                }
                style={{ minWidth: '200px', flex: '0 0 auto' }}
                onClick={() => handleTabChange(index)}
              >
                <h1 className='m-0'>{formatMessage({ id: opt.title })}</h1>
                <p className='mt-2'>{formatMessage({ id: opt.subTitle })}</p>
              </div>
              // <RectangularTabs
              //   key={index}
              //   style={{minWidth: '200px !important'}}
              //   title={opt.title}
              //   subTitle={opt.subTitle}
              //   selectedTab={tab === index + 1}
              //   onClick={() => {
              //     setTab(index + 1)
              //   }}
              // />
            ))}
          </div>
        </div>
        {/* Rectabgular tabs Ends  */}

        {/* Rectabgular tab Content Starts  */}

        <div className='mt-5 mb-9 w-100 px-0 px-md-3'>
          {tab === 1 && (
            <User
              key={tab}
              getApiLoading={getApiLoading}
              setImgName={setImgName}
              imgName={imgName}
              countryOptions={countryOptions}
              stateOptions={stateOptions}
              countryCode={countryCode}
              phoneNumber={phoneNumber}
              getProfileInfo={getProfileInfo}
              setCountryId={setCountryId}
            />
          )}

          {tab === 2 && (
            <Locale
              key={tab}
              getApiLoading={getApiLoading}
              getLocaleApiLoading={getLocaleApiLoading}
              showHelpBanners={showHelpBanners}
              setshowHelpBanners={setshowHelpBanners}
            />
          )}

          {tab === 3 && (
            <NotificationPreferences
              key={tab}
              getPreferences={getPreferences}
              setGetPreferences={setGetPreferences}
              getPreferencesApiLoading={getPreferencesApiLoading}
            />
          )}

          {tab === 4 && <Security key={tab}/>}
          {tab === 5 && (
            <>
              <InfoCard2
                title={'Configuring AI Memory for Your Own Profile to Chat Smarter'}
                desc={
                  'Create personal memory blocks that help RecordsKeeper.AI recall important context during your interactions. These blocks enable the AI to remember relationships beyond basic file data, making conversations more natural and responses more accurate. Your memory blocks are private and only used to enhance your personal experience.'
                }
                desc2={`For example, simply ask "What's my father's passport number?" and the AI immediately provides the details without requiring you to specify names or search through files. The system remembers your personal connections to documents and information, making record retrieval effortless and conversation-like.`}
                slug={
                  'https://help.recordskeeper.ai/en/articles/10956377-ai-memory-personalizing-your-recordskeeper-experience'
                }
              />
              <AIMemory aiMemoryFor={'user'} />
            </>
          )}
          {tab === 6 &&
            (isRKApp ? (
              <ReferralRK key={tab} />
            ) : (
              <Referral
                key={tab}
                paypalId={paypalId}
                referral={referral}
                totalEarning={totalEarning}
                totalReferred={totalReferred}
                setPaypalId={setPaypalId}
              />
            ))}

          {/* {tab === 5 && (
          <OtherUserSettings
            key={tab}
            getApiLoading={getApiLoading}
            showHelpBanners={showHelpBanners}
            setshowHelpBanners={setshowHelpBanners}
          />
        )} */}
        </div>
      </div>
    </>
  )
}
export { UserSettings }
